import styled from "styled-components";

import Card from "@joinTrilo/ui/atoms/Card";
import { colors } from "@joinTrilo/ui/tokens";

import { typography } from "@joinTrilo/ui/tokens";

export const StyledBankSpinner = styled.div`
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    margin-bottom: var(--spacer-3);
`;

export const StyledBankList = styled.div`
    position: relative;
    padding-bottom: 10.8rem;

    height: 100%;
    width: 100%;

    flex: none;
    order: 1;
    flex-grow: 0;
    z-index: 0;

    overflow: hidden;
    overflow-y: auto;
    ::-webkit-scrollbar {
        width: 10px;
        background: transparent;
    }

    ::-webkit-scrollbar-thumb {
        border-right: solid 0.1rem #00bfa5;
        border-radius: 0.2rem;
        height: 6.4rem;
    }
`;

export const StyledBankItem = styled.div<{ isSelected?: boolean }>`
    cursor: pointer;
    height: 6.4rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    box-sizing: content-box;
    border-bottom: solid 1px ${colors.lightSilver};
    background: ${({ isSelected }) =>
        isSelected ? colors.pastelBlue : "none"};
    &:last-child {
        border-bottom: none;
    }
    flex: none;
    order: 1;
    flex-grow: 0;
    width: 100%;
`;

export const StyledLogoWrapper = styled.div`
    width: 4rem;
    height: 4rem;
    padding: 0.2rem;
    margin-left: 2rem;
    align-items: center;
    display: flex;
    justify-content: center;
`;

export const StyledBankLogo = styled.img`
    width: auto;
    height: auto;
    max-height: 100%;
    max-width: 100%;
`;

export const StyledBankName = styled.div`
    margin-left: 2rem;
    font: ${typography.fonts.subHeadingLarge};
`;

export const StyledBankWrapper = styled(Card)`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    isolation: isolate;
    width: 100%;
    height: 100px;
    max-height: 72vh;
    overflow: hidden;

    flex: none;
    order: 0;
    flex-grow: 1;
`;

export const StyledHeaderWrapper = styled.div`
    width: 100%;

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;

    gap: 0.8rem;
    padding: 1.6rem 1.6rem 0.8rem 1.6rem;
`;

export const StyledCardButton = styled.button<{
    hasStripe: boolean;
}>`
    display: ${({ hasStripe }) => (hasStripe ? "flex" : "none")};
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 8px;
    gap: 10px;

    /* Neutrals/light-silver */

    border: 1px solid ${colors.lightSilver};
    border-radius: 20px;
    background-color: inherit;
    /* Inside auto layout */

    flex: none;
    order: 1;
    flex-grow: 0;
    width: 4.8rem;
    height: 4.8rem;
`;

export const StyledCardEmoji = styled.img`
    width: 2.4rem;
    height: 2.4rem;
`;

export const StyledButtonWrapper = styled.div`
    display: flex;
    width: 100%;
`;

export const StyledLegalText = styled.div`
    font: ${typography.fonts.smallSemiBold};
    color: ${colors.darkTurquoise};
    text-align: center;
    width: 100%;
    padding-top: 0.8rem;
`;

export const StyledLegalLink = styled.a`
    color: ${colors.darkTurquoise};
    white-space: nowrap;
`;
